import React, { 
    useState, 
    useEffect 
} from 'react';
import { 
    ResponsiveContainer, 
    PieChart, 
    Pie, 
    Cell, 
    Tooltip 
} from 'recharts';
import { Badge, Form } from 'react-bootstrap';

import { capitalizar } from './../../../../Funcoes';
import styles from './index.module.scss';

const RADIAN = Math.PI / 180;

// componente
export default function GraficoSeguradorasFunil({
    registros,
    retornaNovasSeguradoras=null
}){
    const [dados, alterarDados] = useState([]);    

    // tooltip de quando passa o mouse sobre a celula
    const CustomTooltip = ({ active, payload, label, ...props }) => {
        if (active) {
            const nome = capitalizar(payload[0].name);
            return (
                <div className={[styles.tooltip, 'p-2 rounded shadow-sm bg-light text-secondary text-center'].join(' ')}>
                    <p className="m-0 mr-2">{nome} <Badge variant='secondary'>{payload[0].value}</Badge></p>
                </div>
            )
        }
      
        return null;
    };
    
    const renderCustomizedLabel = ({
        cx, cy, midAngle, innerRadius, outerRadius, percent, index,
        }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        
        return (
            <span stroke="black" strokeWidth="0.3" x={x} y={y} fill="white" fontWeight={'bold'} spanAnchor={'middle'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </span>
        );
    };

    // inicializa
    useEffect(() => {
        // altera o retorno para incluir novos dados
        alterarDados(registros.map(registro => {
            return {
                value: parseInt(registro.total),
                name: registro.dados.nome,
                cor: registro.dados.cor || '#00FF00',
                id: registro.dados.id,
                show: registro?.show ?? true
            };
        }));
    }, [registros]);

    return (
        <>
            <ResponsiveContainer width='100%' height={300}>
                <PieChart>
                    <Pie
                        data={dados.filter(dado => dado.show)}
                        innerRadius={60}
                        outerRadius={120}
                        fill="#8884d8"
                        paddingAngle={2}
                        dataKey="value"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        isAnimationActive={false}
                    >
                        {dados.filter(dado => dado.show).map((entry, index) => 
                            <Cell key={`cell-${index}`} fill={entry.cor} ></Cell>
                        )}
                    </Pie>
                    <Tooltip content={CustomTooltip} />
                </PieChart>
            </ResponsiveContainer>
            <div>
                {dados.map(dado => 
                    <Form.Check 
                        key={dado.name}
                        id={`switch-grafico-${dado.name}`}
                        label={<><Badge className={styles.legendaPizza} style={{background: dado.cor}}>{dado.value}</Badge> {capitalizar(dado.name)}</>}
                        checked={dado.show}
                        onChange={e => {
                            // pega novo valor para verificar se mostra
                            dado.show = e.target.checked;

                            // pega nova referencia dos novos dados
                            const novosDados = [...dados];

                            // altera no estado
                            alterarDados(novosDados);

                            // se passou parametro
                            if(retornaNovasSeguradoras) {
                                // retorna novas seguradoras
                                retornaNovasSeguradoras(novosDados.filter(nd => nd.show));
                            }
                        }}
                        size='sm'
                    />    
                )}
            </div>
        </>
    )

}